'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/6/30.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressChosenComponentTwoLevel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(AddressChosenComponentTwoLevel, _Component);

  function AddressChosenComponentTwoLevel() {
    (0, _classCallCheck3.default)(this, AddressChosenComponentTwoLevel);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(AddressChosenComponentTwoLevel).apply(this, arguments));
  }

  (0, _createClass3.default)(AddressChosenComponentTwoLevel, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var data = _props.data;
      var onAddressChange = _props.onAddressChange;
      var formProps = _props.formProps;

      var styles = require('./AddressChosenComponent.scss');
      // console.log(value); value
      var oneOptions = [];
      var twoOptions = [];
      if (data) {
        if (data.one instanceof Array) {
          oneOptions = data.one.map(function (info, index) {
            return _react2.default.createElement(
              'option',
              { key: index, value: info.VALUE },
              info.TEXT
            );
          });
        }
        oneOptions.splice(0, 0, _react2.default.createElement(
          'option',
          { key: 'null', value: '' },
          ' -- 省 -- '
        ));

        if (data.two instanceof Array) {
          twoOptions = data.two.map(function (info, index) {
            return _react2.default.createElement(
              'option',
              { key: index, value: info.VALUE },
              info.TEXT
            );
          });
        }
      }
      twoOptions.splice(0, 0, _react2.default.createElement(
        'option',
        { key: 'null', value: '' },
        ' -- 市 -- '
      ));
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'label',
          null,
          '地区：'
        ),
        _react2.default.createElement(
          'div',
          { className: styles.selectGroup },
          _react2.default.createElement(
            'select',
            { onChange: function onChange(event) {
                return onAddressChange(event.target.value, 'two');
              } },
            oneOptions
          ),
          ',',
          _react2.default.createElement(
            'select',
            (0, _extends3.default)({ onChange: function onChange(event) {
                return onAddressChange(event.target.value);
              } }, formProps),
            twoOptions
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return AddressChosenComponentTwoLevel;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object,
  value: _react.PropTypes.string,
  onAddressChange: _react.PropTypes.func,
  formProps: _react.PropTypes.object
}, _temp);
exports.default = AddressChosenComponentTwoLevel;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AddressChosenComponent/AddressChosenComponentTwoLevel.js
 ** module id = 1305
 ** module chunks = 0
 **/